import React, { useEffect, useRef, useState } from 'react';
import { intl } from '@fullstory/intl';
import { Modal, TextInput, InputDescription, Box, InputLabel } from '@fullstory/components';
import { MAX_DESCRIPTION_LENGTH } from '../../../constants';
import { FormattedMessage } from 'react-intl';
import { DescriptionMarkdownPreview } from '@fullstory/junk-drawer-ui';

export const NameModal: React.FC<{
  title: string;
  value: string;
  description: string;
  error?: string;
  buttonText: string;
  onChange: (value: string) => void;
  onChangeDescription?: (value: string) => void;
  onSubmit: () => void;
  onCloseSignal: () => void;
  open?: boolean;
}> = ({
  title,
  value,
  description,
  error,
  buttonText,
  onChange,
  onChangeDescription,
  onSubmit,
  onCloseSignal,
  open = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [saveDisabled, setSaveDisabled] = useState(false);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Modal data-component="NameModal" onCloseSignal={() => onCloseSignal()} open={open}>
      <Modal.Header onCloseSignal={() => onCloseSignal()}>{title}</Modal.Header>
      <Modal.Body>
        <form
          onSubmit={e => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Box display="flex" flexDirection="column" gap={8}>
            <InputLabel htmlFor="title-input">
              <FormattedMessage defaultMessage="Name" id="HAlOn1" />
            </InputLabel>
            <TextInput
              ref={inputRef}
              value={value}
              id="title-input"
              testId="name-input"
              onChange={e => {
                onChange(e.target.value);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  e.stopPropagation();
                  onSubmit();
                }
              }}
              placeholder={intl.formatMessage({
                defaultMessage: 'Name',
                id: 'HAlOn1',
              })}
              invalid={!!error}
            />
            {!!error && <InputDescription invalid description={error} />}
            {onChangeDescription && (
              <>
                <InputLabel htmlFor="description-input" optional>
                  <FormattedMessage defaultMessage="Description" id="Q8Qw5B" />
                </InputLabel>
                <DescriptionMarkdownPreview
                  id="description-input"
                  testId="rename-modal-description-input"
                  onChange={e => onChangeDescription(e.target.value)}
                  value={description}
                  rows={3}
                  maxLength={MAX_DESCRIPTION_LENGTH}
                  preventNewline
                  setSaveDisabled={setSaveDisabled}
                />
              </>
            )}
          </Box>
        </form>
      </Modal.Body>
      <Modal.FooterActions
        primaryAction={{ action: () => onSubmit(), text: buttonText, disabled: saveDisabled }}
        isBar
      />
    </Modal>
  );
};
